import style from './Bookmarks.module.scss'

let Bookmarks = () => {

    var arr2: string[] = [];

    if (localStorage.getItem('NameMovie') !== null) {
        const arr = localStorage.getItem('NameMovie');
        if (arr !== null) {
            arr2 = JSON.parse(arr)
        }
    } else {
        arr2 = []
    }

    function localdel() {
        localStorage.clear()
        localStorage.removeItem('NameMovie')
        arr2 = []
    }

    return (
        <div className={style.Bookmarks}>
            <div className={style.Bookmarks__header}>
                <div className={style.header__name}>Bookmarks</div>
                <div className={style.header__count}>Quantity: {arr2.length}</div>
                <div className={style.header__del} onClick={localdel}>Delete all</div>
            </div>
            <div className={style.Bookmarks__box}>
                {arr2.map((el: string) => <div className={style.box__element}><span>{el}</span><button>Watch Now</button></div>)}
            </div>
        </div>
    )
}

export default Bookmarks;